import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navLinks = [
    { label: "Our Story", href: "#story" },
    { label: "Our Range", href: "#collection" },
    { label: "Rice Guide", href: "#rice-guide" },
    { label: "Testimonials", href: "#testimonials" },
  ];

  return (
    <nav
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-brand-primary/95 backdrop-blur-xl border-b border-brand-gold/20 shadow-lg"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 flex items-center justify-between h-28 md:h-36">
        {/* Logo */}
        <a
          href="#hero"
          data-testid="navbar-logo"
        >
          <img
            src="https://customer-assets.emergentagent.com/job_rice-elegance/artifacts/xrreke3a_Untitled%20design.png"
            alt="Sartaj"
            className="h-24 md:h-32 w-auto object-contain"
          />
        </a>

        {/* Desktop Links */}
        <div className="hidden md:flex items-center gap-10">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              data-testid={`nav-link-${link.label.toLowerCase().replace(/\s/g, "-")}`}
              className="nav-link text-xs uppercase tracking-[0.25em] text-brand-text-light/80 hover:text-brand-gold transition-colors duration-300 font-body font-medium"
            >
              {link.label}
            </a>
          ))}
        </div>

        {/* Mobile Menu Button */}
        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden text-brand-text-light"
          onClick={() => setMobileOpen(!mobileOpen)}
        >
          {mobileOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div
          data-testid="mobile-menu"
          className="md:hidden bg-brand-primary/98 backdrop-blur-xl border-t border-brand-gold/10 px-6 py-8"
        >
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              onClick={() => setMobileOpen(false)}
              className="block py-4 text-sm uppercase tracking-[0.2em] text-brand-text-light/80 hover:text-brand-gold transition-colors border-b border-brand-gold/10 last:border-0 font-body"
            >
              {link.label}
            </a>
          ))}
        </div>
      )}
    </nav>
  );
};

export default Navbar;
